const endpointConst = {
  // productList: "/columbus/v1/productList",
  geojs: "geojs",
};

const cacheKeyConst = {
  [endpointConst.geojs]: "geojs",
};

export { endpointConst, cacheKeyConst };
